<template>
  <v-container>
    <v-layout justify-center>
      <v-flex lg6 md8 sm8 xs12>
        <v-card>
          <v-card-title> Server anlegen </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout justify-space-between wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="serverName"
                    label="Name"
                    :disabled="$store.state.query.loading"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="serverPort"
                    label="Port"
                    type="number"
                    :disabled="$store.state.query.loading"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="maxClients"
                    label="Max. Benutzer"
                    type="number"
                    :disabled="$store.state.query.loading"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <key-text-field
                    v-model="token"
                    label="Erzeugter Einladungsschlüssel (Admin)"
                  ></key-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="createServer" :disabled="!valid" color="primary"
              >Anlegen</v-btn
            >
            <v-btn text @click="$router.go(-1)" color="primary">Schließen</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {
    KeyTextField: () => import("@/components/KeyTextField"),
  },
  data() {
    return {
      valid: false,
      servers: [],
      serverName: "",
      serverPort: undefined,
      maxClients: 32,
      rules: {
        required: (value) => !!value || "Pflichtfeld.",
      },
      token: "",
    };
  },
  methods: {
    getServerList() {
      return this.$TeamSpeak.execute("serverlist");
    },
    getAvailablePort() {
      return (
        Math.max(...this.servers.map((server) => server.virtualserverPort)) + 1
      );
    },
    async createServer() {
      try {
        let [response] = await this.$TeamSpeak.execute("servercreate", {
          virtualserverName: this.serverName,
          virtualserverPort: this.serverPort,
          virtualserverMaxclients: this.maxClients,
        });

        this.token = response.token;

        this.$toast.success("Server wurde angelegt");

        await this.$TeamSpeak.selectServer(response.sid);
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
  },
  async created() {
    try {
      this.servers = await this.getServerList();
      this.serverPort = this.getAvailablePort();
    } catch (err) {
      this.$toast.error(err.message);
    }
  },
};
</script>
